import "core-js/modules/es6.array.map";
import React, { memo } from 'react';
import SummaryCell from './SummaryCell';

function SummaryRow(_ref) {
  var rowIdx = _ref.rowIdx,
      lastFrozenColumnIndex = _ref.lastFrozenColumnIndex,
      row = _ref.row,
      viewportColumns = _ref.viewportColumns,
      bottom = _ref.bottom,
      ariaRowIndex = _ref['aria-rowindex'];
  return /*#__PURE__*/React.createElement("div", {
    role: "row",
    "aria-rowindex": ariaRowIndex,
    className: "rdg-row rdg-row-" + (rowIdx % 2 === 0 ? 'even' : 'odd') + " rdg-summary-row",
    style: {
      bottom: bottom
    }
  }, viewportColumns.map(function (column) {
    return /*#__PURE__*/React.createElement(SummaryCell, {
      key: column.key,
      column: column,
      lastFrozenColumnIndex: lastFrozenColumnIndex,
      row: row
    });
  }));
}

export default /*#__PURE__*/memo(SummaryRow);